import styles from "./ServiceCard.module.css";
import { Link } from "react-router-dom";

export default function ServiceCard({ id, icon, titulo }) {
  return (
    <Link to={`/servicios/${id}`} className={styles.card}>
      <div className={styles.icon}>{icon}</div>
      <h3 className={styles.title}>{titulo}</h3>
    </Link>
  );
}
